/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: EditorInstanceManager.ts
 * Project: mle-client-n
 * Committed last: 2022/6/7 @ 1832
 * ---
 * Description:
 */

import { Editor, StoreInitParams } from './Editor';

export class EditorInstanceManager {
  private static instance?: Editor;

  protected constructor() {}

  static getInstance(initParams: StoreInitParams) {
    if (!EditorInstanceManager.instance)
      EditorInstanceManager.instance = new Editor(initParams);
    return EditorInstanceManager.instance;
  }

  static destroy() {
    EditorInstanceManager.instance = undefined;
  }
}